// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1LVfx","footer":"ChangeClinic_footer__-FiSA"};